export default "__VITE_ASSET__DrxVXQZ7__"